import React, {useContext} from 'react'
import {queryClient as qc} from 'keys'
import {getProsodyDoughnutChart} from 'store/middlewares/assessment.crud'
import {useQuery} from '@tanstack/react-query'
import {useSelector} from 'react-redux'
import {AssessmentsContext} from './AssessmentsContext'
import DoughnutCharts from './DoughnutCharts'

const DoughnutChartsPage = (props) => {
    const { assessmentFilters, assessmentCount } = useContext(AssessmentsContext)
    const { headerFilters } = useSelector(state => state.header)
    const { testTaker } = useSelector(state => state.testTaker)

    // const doughnutCharts = useQuery({
    //     queryKey: [qc.doughnutCharts, headerFilters, testTaker],
    //     queryFn: async ({signal}) => {
    //         alert("DoughnutChartsContext")
    //         const { data } = await getDoughnutChartsFetch({ assessmentFilters, headerFilters, testTaker, signal })
    //         return data
    //     }
    // })

    // const fluencyDoughnut = useQuery({
    //     queryKey: [qc.fluencyDoughnut, headerFilters, testTaker],
    //     queryFn: async ({ signal }) => {
    //         const { data } = await getFluencyDoughnutChart({ assessmentFilters, headerFilters, testTaker, signal })
    //         return data
    //     },
    //     refetchOnWindowFocus: false,
    // })
    // const percentAccuracyDoughnut = useQuery({
    //     queryKey: [qc.percentAccuracyDoughnutChart, headerFilters, testTaker],
    //     queryFn: async ({ signal }) => {
    //         const { data } = await getPercentAccuracyDoughnutChart({ assessmentFilters, headerFilters, testTaker, signal })
    //         return data
    //     },
    //     refetchOnWindowFocus: false,
    // })
    // const factoredPercentAccuracyDoughnut = useQuery({
    //     queryKey: [qc.factoredPercentAccuracyDoughnut, headerFilters, testTaker],
    //     queryFn: async ({ signal }) => {
    //         const { data } = await getFactoredPercentAccuracyDoughnutChart({ assessmentFilters, headerFilters, testTaker, signal })
    //         return data
    //     },
    //     refetchOnWindowFocus: false,
    // })
    // const fluencyReadingDoughnut = useQuery({
    //     queryKey: [qc.fluencyReadingDoughnut, headerFilters, testTaker],
    //     queryFn: async ({ signal }) => {
    //         const { data } = await getFluencyReadingDoughnutChart({ assessmentFilters, headerFilters, testTaker, signal })
    //         return data
    //     },
    //     refetchOnWindowFocus: false,
    // })
    // const correctWordsPerMinuteDoughnut = useQuery({
    //     queryKey: [qc.correctWordsPerMinuteDoughnut, headerFilters, testTaker],
    //     queryFn: async ({ signal }) => {
    //         const { data } = await getCorrectWordPerMinuteDoughnutChart({ assessmentFilters, headerFilters, testTaker, signal })
    //         return data
    //     },
    //     refetchOnWindowFocus: false,
    // })
    const prosodyDoughnut = useQuery({
        queryKey: [qc.prosodyDoughnut, headerFilters, testTaker],
        queryFn: async ({ signal }) => {
            const { data } = await getProsodyDoughnutChart({ assessmentFilters, headerFilters, testTaker, signal })
            return data
        },
       // staleTime: 90 * 1000
    })

    const commonState = {
        // fluencyDoughnut,
        // percentAccuracyDoughnut,
        // factoredPercentAccuracyDoughnut,
        // fluencyReadingDoughnut,
        // correctWordsPerMinuteDoughnut,
        prosodyDoughnut,
        // doughnutCharts
    }

    return (
        <DoughnutChartsContext.Provider value={commonState}>
            <DoughnutCharts assessmentCount={assessmentCount} />
        </DoughnutChartsContext.Provider>
    )
}

export const DoughnutChartsContext = React.createContext()
export default DoughnutChartsPage